<template>
  <div class="app-container">
    <div class="edit-mima-section">
      <el-form ref="dataForm2"
               :rules="passwordRules"
               :model="passwordData"
               label-position="right"
               label-width="100px"
               v-loading="pwdDialogFormLoading">
        <span class="custom-tips">
          您的密码已过期，请重新修改密码
        </span>
        <el-form-item label="新密码"
                      prop="password">
          <div class="at-row">
            <el-input ref="password2"
                      :type="passwordType2"
                      v-model="passwordData.password" />
            <span class="show-pwd"
                  @click="showPwd2">
              <svg-icon :icon-class="passwordType2 === 'password'? 'eye': 'eye-open'" />
            </span>
          </div>
          <span>*必须6-15位，且必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _</span>
        </el-form-item>
        <el-form-item :label="$t('login.confirmPassword')"
                      prop="confirm_password">
          <div class="at-row">
            <el-input ref="confirmPassword2"
                      :type="confirmPasswordType2"
                      v-model="passwordData.confirm_password" />
            <span class="show-pwd"
                  @click="showConfirmPwd2">
              <svg-icon :icon-class="confirmPasswordType2 === 'password'? 'eye': 'eye-open'" />
            </span>
          </div>
        </el-form-item>
      </el-form>
      <el-button style="min-width: 117px;display: block; margin: 0 auto; background: #1067E0;font-size: 16px;"
                 size="mini"
                 type="primary"
                 @click="confirmImport('dataForm2')">提交</el-button>
    </div>

  </div>
</template>

    <script>
import store from '@/store'
import md5 from "js-md5";
import {
  password,
} from "@/api/user";
export default {
  data () {
    const pwdCheck = (rule, value, callback) => {
      let numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
      let englishAlphabet = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f',
        'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm'];
      let specialCharacters = ['!', '@', '#', '$', '%', '&', '.', '_'];
      let isNumber = false;
      let isEnglishAlphabet = false;
      let isBigEnglishAlphabet = false;
      let isSpecialCharacters = false;
      numbers.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isNumber = true;
        }
      });
      englishAlphabet.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isEnglishAlphabet = true;
        }
        if (value.indexOf(item.toUpperCase()) !== -1) {
          isBigEnglishAlphabet = true;
        }
      });
      specialCharacters.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isSpecialCharacters = true;
        }
      });
      if (isNumber && isEnglishAlphabet && isBigEnglishAlphabet && isSpecialCharacters) {
        callback();
      } else {
        callback(new Error("密码格式错误"));
      }
    };
    var validateConfirmPassword2 = (rule, value, callback) => {
      if (value === undefined || value === "") {
        callback(new Error(this.$t("login.pleaseEnterPassword")));
      } else if (value !== this.passwordData.password) {
        callback(new Error(this.$t("user.confirmPasswordError")));
      } else {
        callback();
      }
    };
    return {
      showImportModalStatus: false,
      currentId: 0,
      passwordRules: {
        password: [
          { required: true, message: "密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur",
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
        confirm_password: [
          {
            required: true,
            validator: validateConfirmPassword2,
            trigger: "blur",
          },
        ],
      },
      passwordType2: "password",
      confirmPasswordType2: "password",
      passwordData: {
        id: undefined,
        password: "",
        confirm_password: "",
      },
      pwdDialogFormLoading: false,
    };
  },
  components: {
  },
  created () {
    this.currentId = store.getters.admin_id;
  },
  mounted () {
  },
  methods: {
    showPwd2 () {
      if (this.passwordType2 === "password") {
        this.passwordType2 = "";
      } else {
        this.passwordType2 = "password";
      }
      this.$nextTick(() => {
        this.$refs.password2.focus();
      });
    },
    showConfirmPwd2 () {
      if (this.confirmPasswordType2 === "password") {
        this.confirmPasswordType2 = "";
      } else {
        this.confirmPasswordType2 = "password";
      }
      this.$nextTick(() => {
        this.$refs.confirmPassword2.focus();
      });
    },
    /**
   * @name: 修改密码
   * @return {*}
   * @desc:
   */
    confirmImport () {
      this.$refs["dataForm2"].validate((valid) => {
        if (valid) {
          let params = {
            // admin_id: this.currentId,
            admin_id: this.currentId,
            password: this.passwordData.password,
            confirm_password: this.passwordData.confirm_password,
          };
          password(params).then(res => {
            // this.$message.success(this.$t("form.updateSuccess"));
            if (res.code == 200) {
              this.$store.dispatch('user/logout')
              this.$router.push(`/login`)
            }

          });
        }
      });
    },
  }
};
    </script>

    <style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
.edit-mima-section {
  width: 40%;
  margin: 0 auto;
}
.custom-tips {
  color: #ff4949;
  margin-bottom: 18px;
  display: block;
  text-align: center;
}
.at-row {
  display: flex;
}
.at-row .show-pwd {
  margin-left: 10px;
}
</style>
